// src/config/api.js

// API base URL should be ONLY the origin (scheme + host [+ optional port]).
// Do NOT append "/api" or any other path here, because callers already append
// their own prefixes (e.g. /web2/, /apiv2/, etc.).

const ENV_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const isDev = process.env.NODE_ENV === "development";

// Guard for non-browser environments
const hostname = typeof window !== "undefined" && window.location ? window.location.hostname : "";

const protocol =
  typeof window !== "undefined" && window.location ? window.location.protocol : "http:";

const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";

// Default behavior:
// - Dev on localhost: talk to local backend on :8000
// - Any other domain (staging/prod, including reverse-proxied domains): use same-origin
const API_BASE_URL =
  ENV_BASE_URL ||
  (isDev && isLocalHost ? `${protocol}//${hostname}:8000` : `${protocol}//${hostname}`);

export default API_BASE_URL;
